import axios from "axios";
import { parseISO } from "date-fns";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PaginationMetadata, PortfolioPlanId, } from "../../Types";
import ValidationError from "../../ZodError";
export const url = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}/usage/parents`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}/usage/parents`;
const Response = z.object({
    data: z
        .object({
        parent: PortfolioPlanId,
        effectiveWeight: z.string().transform((v) => new Decimal(v)),
        immediateWeight: z.string().transform((v) => new Decimal(v)),
        immediateParent: z.boolean(),
        createdAt: z
            .string()
            .datetime()
            .transform((v) => parseISO(v)),
    })
        .array(),
    pagination: PaginationMetadata,
});
export const getPortfolioPlanParentUsage = async (portfolioPlanId, config) => {
    const { data } = await axios.get(url(portfolioPlanId), {
        headers: {
            version: "20240910",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getPortfolioPlanClientUsage] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getPortfolioPlanParentUsage.js.map